import ListPurchaseReturns from "../../../../components/@documents/purchase_returns/ListPurchaseReturns";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseReturnsPage() {

    return (
        <ListPurchaseReturns 
            routeType={routeTypes.workstation}
        />
    )
}